import { useState, useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  size_with_price,
  get_regions,
  edit_sizes,
  update_size_gender,
  delete_size,
  add_sizes,
} from "../../reduxData/user/userAction";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import DeletePopup from "../../Modals/DeletePopup";

const ViewSizes = ({ type }) => {
  const [language, setLang] = useState("English");
  const lang = ["English", "Arabic"];
  const { user } = useSelector((state) => state.auth);

  const { selectedCategory, selectedBrand, selectedGender } = useParams();
  const navigate = useNavigate();

  const [openSize, setOpenSize] = useState(false);
  const [sizeId, setSizeId] = useState("");

  const [selectedSizeCategory, setSelectedSizeCategory] = useState([]);
  const [activeCategoryTab, setActiveCategoryTab] = useState(null);
  const [options, setOptions] = useState([]);
  const [region, setRegion] = useState([]);
  const [defaultRegions, setDefaultRegions] = useState([]);
  const [defaultCategories, setDefaultCategories] = useState([]);
  const [all, setAll] = useState([]);
  const [selectedSizeRegion, setSelectedSizeRegion] = useState([]);
  const [availableRegions, setAvailableRegions] = useState();
  const [addSizesLines, setAddSizesLines] = useState([]);
  const [editSizeId, setEditSizeId] = useState("");

  const handleRegion = async () => {
    const res = await get_regions();
    setAvailableRegions(res?.data);
  };

  const handleGetSize = useCallback(
    async (id) => {
      const res = await size_with_price(
        selectedCategory,
        selectedBrand,
        selectedGender
      );
      const filterData = res?.data?.filter((i) => !i?.size_deleted);

      const sizeArray = filterData?.map((item) => item?.size_text);

      const sortedData = res?.data?.filter((i) => !i?.size_deleted);
      // ?.sort((a, b) => {
      //   const sizeA = a?.size_text?.[0]?.text || "";
      //   const sizeB = b?.size_text?.[0]?.text || "";

      //   return sizeA.localeCompare(sizeB, undefined, { numeric: true });
      // });

      setOptions(sortedData);

      setRegion(sizeArray[0]);
      setDefaultRegions(filterData?.[0]?.region_id);
      setDefaultCategories(filterData?.[0]?.category_ids);
    },
    [selectedCategory, selectedBrand, selectedGender]
  );

  const handleAddSizes = async () => {
    const currentGenderData = all.find((g) => g.gender_id == selectedGender);
    console.log("cuurent", currentGenderData);
    if (currentGenderData) {
      const payload = {
        size_id: currentGenderData.size_id,
        gender_id: currentGenderData.gender_id,
      };
      await update_size_gender(payload);
    }
  };

  const handleDeleteLine = (id) => {
    const filteredLines = addSizesLines?.filter((i) => i?.id != id);
    setAddSizesLines(filteredLines);
  };

  const addTextRelatedRegions = (text, idx, id) => {
    setAddSizesLines((prev) =>
      prev?.map((line) => {
        if (line.id !== id) return line;

        return {
          ...line,
          region: line?.region?.map((r, rIdx) =>
            rIdx == idx ? { ...r, text } : r
          ),
        };
      })
    );
  };

  const addTextRelatedRegions_ar = (text_ar, idx, id) => {
    setAddSizesLines((prev) =>
      prev?.map((line) => {
        if (line.id !== id) return line;

        return {
          ...line,
          region: line?.region?.map((r, rIdx) =>
            rIdx == idx ? { ...r, text_ar } : r
          ),
        };
      })
    );
  };

  const sizeRegions = useMemo(() => {
    if (selectedSizeRegion?.length > 0) {
      return selectedSizeRegion[0]
        .map((i) => {
          if (i === 0)
            return { id: 0, region: "Default", region_ar: "افتراضي" };
          return availableRegions?.find((ii) => ii?.id == i);
        })
        .filter(Boolean);
    }
    return [];
  }, [selectedSizeRegion, availableRegions]);

  const handleSaveChanges = async () => {
    const editingOption = options?.find((i) => i?.size_id == editSizeId);
    if (!editingOption) return;

    const payload = {
      gender_id: editingOption?.gender_id ?? selectedGender,
      type_id: editingOption?.type_id ?? selectedCategory,
      brand_id: editingOption?.brand_id ?? selectedBrand,
      category_id:
        editingOption?.category_id ?? activeCategoryTab ?? selectedSizeCategory,
      size_id: editSizeId,
      size_text: editingOption?.size_text,
    };

    try {
      await edit_sizes(payload);
    } finally {
      await handleGetSize();
      setEditSizeId("");
    }
  };
  const handleEditClick = async (size_id) => {
    if (editSizeId && editSizeId !== size_id) {
      await handleSaveChanges();
    }

    setEditSizeId(size_id);
  };
  const handleEditSize = (text, regionId, size_id) => {
    setOptions((prev) =>
      prev?.map((option) => {
        if (option.size_id !== size_id) return option;

        const existing = Array.isArray(option.size_text)
          ? option.size_text
          : [];
        const hasRegion = existing.some((t) => t.region == regionId);

        return {
          ...option,
          size_text: hasRegion
            ? existing.map((t) => (t.region == regionId ? { ...t, text } : t))
            : [...existing, { region: regionId, text }],
        };
      })
    );
  };
  const handleEditSize_ar = (text_ar, regionId, size_id) => {
    setOptions((prev) =>
      prev?.map((option) => {
        if (option.size_id !== size_id) return option;

        const existing = Array.isArray(option.size_text)
          ? option.size_text
          : [];
        const hasRegion = existing.some((t) => t.region == regionId);

        return {
          ...option,
          size_text: hasRegion
            ? existing.map((t) =>
                t.region == regionId ? { ...t, text_ar } : t
              )
            : [...existing, { region: regionId, text_ar }],
        };
      })
    );
  };

  const handleDeleteSize = async () => {
    const res = await delete_size(sizeId);
    if (res) {
      handleGetSize();
    }
    setSizeId("");
    setOpenSize(false);
  };

  const sizeChartOfGender = options?.filter(
    (i) =>
      i?.gender_id == selectedGender &&
      i?.brand_id == selectedBrand &&
      i?.type_id == selectedCategory
  );
  // console.log(selectedGender, selectedBrand,selectedCategory, "size chart ", sizeChartOfGender);
  const regionOfGender = sizeChartOfGender?.[0]?.size_text;

  const groupedByCategory = useMemo(() => {
    if (!Array.isArray(options)) return {};
    return options.reduce((acc, item) => {
      if (item?.category_id == undefined) return acc;

      if (!acc[item.category_id]) {
        acc[item.category_id] = {
          category_id: item.category_id,
          category_name: item.category_name,
          region_id: item.region_id ?? [],
          sizes: [],
        };
      }

      acc[item.category_id].sizes.push(item);
      return acc;
    }, {});
  }, [options]);

  // Memoized regions for active category
  const activeCategoryRegions = useMemo(() => {
    if (activeCategoryTab == null || activeCategoryTab === undefined) return [];

    const categoryData = groupedByCategory?.[activeCategoryTab];
    let regions = [];

    if (selectedSizeRegion?.[0]?.length > 0) {
      regions = selectedSizeRegion[0]
        .map((i) => {
          if (i == 0) return { id: 0, region: "Default", region_ar: "افتراضي" };
          return availableRegions?.find((ii) => ii?.id == i);
        })
        .filter(Boolean);
    } else if (categoryData) {
      const categoryRegionIds =
        Array.isArray(categoryData?.region_id) &&
        categoryData.region_id.length > 0
          ? Array.isArray(categoryData.region_id[0])
            ? categoryData.region_id[0]
            : categoryData.region_id
          : [];
      regions = categoryRegionIds
        .map((i) => {
          if (i == 0) return { id: 0, region: "Default", region_ar: "افتراضي" };
          return availableRegions?.find((ii) => ii?.id == i);
        })
        .filter(Boolean);
    }

    return regions.length > 0
      ? regions
      : [{ id: 0, region: "Default", region_ar: "افتراضي" }];
  }, [
    activeCategoryTab,
    groupedByCategory,
    selectedSizeRegion,
    availableRegions,
  ]);

  const handleAddSizesApi = async () => {
    if (activeCategoryTab == undefined) return;

    const sizesForActiveCategory = addSizesLines.filter(
      (i) => i.category_id == activeCategoryTab
    );

    if (sizesForActiveCategory.length == 0) return;

    const size_text = sizesForActiveCategory.map((row) =>
      row.region
        .filter((r) => r !== undefined && r !== null)
        .map((r) => ({
          region: r.id, // "US M", "UK" or 0 for Default
          ...(r.text ? { text: r.text, text_ar: r.text_ar } : {}),
        }))
    );

    const payload = {
      size: [
        {
          gender_id: String(selectedGender),
          brand_id: String(selectedBrand),
          type_id: String(selectedCategory),
          category_id: String(activeCategoryTab),
          category_ids: defaultCategories,
          // selectedSizeCategory?.map(i=>({id:i?.id,category_name:i?.region})),
          region_id: defaultRegions,
          // selectedSizeRegion?.[0]?.id,
          size_text,
        },
      ],
    };

    console.log("selcted sisze region", payload);

    const res = await add_sizes(payload);
    //          if(res)
    //       {
    //         const newlyCreatedSizes = res.data.map(item => ({
    //   ...item,
    //   category_name:
    //     options.find(o => o.category_id == item.category_id)?.category_name || "",
    // }));

    //   setOptions((prev) => [...prev, ...newlyCreatedSizes]);
    //          }

    setAddSizesLines([]);
    handleGetSize();
  };

  const handleAddSizesEmptyLines = () => {
    if (activeCategoryTab == null || activeCategoryTab === undefined) return;

    const regionsToUse =
      activeCategoryRegions.length > 0
        ? activeCategoryRegions
        : sizeRegions.length > 0
        ? sizeRegions
        : [{ id: 0, region: "Default", region_ar: "افتراضي" }];

    setAddSizesLines((prev) => {
      const newRow = {
        id: uuidv4(),
        category_id: activeCategoryTab,
        region: regionsToUse,
      };
      return prev?.length > 0 ? [...prev, newRow] : [newRow];
    });
  };

  console.log("add sizes lines", addSizesLines, "edited row");

  const extractedCategories = useMemo(() => {
    if (!groupedByCategory || Object.keys(groupedByCategory).length === 0)
      return [];

    return Object.values(groupedByCategory).map((categoryData) => ({
      id: categoryData.category_id,
      region:
        categoryData.category_name || `Category ${categoryData.category_id}`,
      category_name: categoryData.category_name,
    }));
  }, [groupedByCategory]);

  useEffect(() => {
    if (
      selectedGender != undefined &&
      selectedCategory != undefined &&
      selectedBrand != undefined
    ) {
      if (extractedCategories.length > 0) {
        setSelectedSizeCategory((prev) => {
          const prevIds = prev
            ?.map((cat) => (typeof cat === "object" ? cat?.id : cat))
            .sort()
            .join(",");
          const newIds = extractedCategories
            .map((cat) => cat.id)
            .sort()
            .join(",");
          if (prevIds === newIds) return prev;
          return extractedCategories;
        });
      } else {
        setSelectedSizeCategory((prev) => prev || []);
      }
    } else {
      setSelectedSizeCategory((prev) => (prev?.length > 0 ? [] : prev));
    }
  }, [extractedCategories, selectedGender, selectedCategory, selectedBrand]);

  useEffect(() => {
    if (
      Array.isArray(selectedSizeCategory) &&
      selectedSizeCategory.length > 0
    ) {
      const firstCategory = selectedSizeCategory[0];
      const firstCategoryId =
        typeof firstCategory === "object" && firstCategory !== null
          ? Array.isArray(firstCategory)
            ? firstCategory[0]
            : firstCategory?.id
          : firstCategory;

      if (firstCategoryId != undefined) {
        const isCurrentTabValid = selectedSizeCategory.some((cat) => {
          const catId = typeof cat === "object" && cat !== null ? cat?.id : cat;
          return catId == activeCategoryTab;
        });

        if (!activeCategoryTab || !isCurrentTabValid) {
          setActiveCategoryTab(firstCategoryId);
        }
      }
    } else {
      setActiveCategoryTab(null);
    }
  }, [selectedSizeCategory]);

  useEffect(() => {
    const categoryId =
      typeof activeCategoryTab === "object" && activeCategoryTab !== null
        ? activeCategoryTab?.id
        : activeCategoryTab;

    if (!categoryId || !groupedByCategory?.[categoryId]) return;

    const categoryData = groupedByCategory[categoryId];
    const categoryRegionIds =
      Array.isArray(categoryData?.region_id) &&
      categoryData.region_id.length > 0
        ? Array.isArray(categoryData.region_id[0])
          ? categoryData.region_id[0]
          : categoryData.region_id
        : [];

    if (categoryRegionIds.length > 0) {
      const currentRegionIds = selectedSizeRegion?.[0] || [];
      const isDifferent =
        JSON.stringify(currentRegionIds.sort()) !==
        JSON.stringify(categoryRegionIds.sort());

      if (
        selectedSizeRegion.length === 0 ||
        !selectedSizeRegion[0] ||
        selectedSizeRegion[0].length === 0 ||
        isDifferent
      ) {
        setSelectedSizeRegion([categoryRegionIds]);
        // console.log("test",region)
      }
    }
  }, [activeCategoryTab, groupedByCategory]);

  useEffect(() => {
    if (
      selectedGender != null &&
      selectedGender !== "" &&
      selectedCategory != null &&
      selectedCategory !== "" &&
      selectedBrand != null &&
      selectedBrand !== ""
    ) {
      setEditSizeId("");
      setAddSizesLines([]);
    }
  }, [selectedGender, selectedCategory, selectedBrand]);

  useEffect(() => {
    handleGetSize();
    handleRegion();
  }, []);

  console.log("selected size catgeory tabs", selectedSizeCategory);
  return (
    <div className="col-12 py-3">
      <div className="d-flex gap-4 justify-content-between align-items-center">
        <div onClick={() => type!="deleted" ? navigate("/size"): navigate("/restore-size")}>
          <i class="bi bi-arrow-left cursor-pointer"></i>
        </div>
        <div className="d-flex justify-content-end align-items-center gap-4 ">
          {type!="deleted" && <button
            class="mt-2 btn btn-primary rounded-2 px-2  "
            onClick={() => {
              handleAddSizesEmptyLines();
            }}
          >
            Add Sizes
          </button>
          }

          {addSizesLines?.length > 0 && (
            <button class="mt-2 btn  btn-success" onClick={handleAddSizesApi}>
              Submit
            </button>
          )}
        </div>
      </div>

      {/* Category Tabs - Based on selectedSizeCategory array */}

      <div className="d-flex justify-content-between my-2">
        <div className="d-flex gap-2">
          {Array.isArray(selectedSizeCategory) &&
            selectedSizeCategory.length > 0 &&
            selectedSizeCategory?.map((categoryId, idx) => {
              // Extract ID from categoryId (handle object, array, or number)
              const catId =
                typeof categoryId === "object" && categoryId !== null
                  ? Array.isArray(categoryId)
                    ? categoryId[0]
                    : categoryId?.id
                  : categoryId;
              // Get category name from options or use ID
              if (!catId) return null;
              const categoryInfo = options?.find(
                (opt) => opt.category_id == catId
              );
              const categoryName =
                categoryInfo?.category_name ||
                categoryInfo?.product_type_name ||
                (typeof categoryId === "object"
                  ? categoryId?.region
                  : `Category ${catId}`);

              return (
                <button
                  key={idx}
                  type="button"
                  className={`btn btn-sm ${
                    activeCategoryTab == catId
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => setActiveCategoryTab(catId)}
                >
                  {categoryName}
                </button>
              );
            })}
        </div>
        <div className="d-flex gap-1">
          {lang?.map((value, index) => (
            <button
              key={index}
              onClick={() => setLang(value)}
              className={`btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3
           ${
             language === value
               ? "btn-primary active-lang hindi-btn text-white"
               : "hindi-btn"
           }`}
            >
              {value}
            </button>
          ))}
        </div>
      </div>

      {(() => {
        const getCategoryId = (cat) => {
          if (!cat) return null;
          if (typeof cat === "object") {
            return Array.isArray(cat) ? cat[0] : cat?.id;
          }
          return cat;
        };

        const currentActiveTab = activeCategoryTab
          ? typeof activeCategoryTab === "object"
            ? activeCategoryTab?.id
            : activeCategoryTab
          : Array.isArray(selectedSizeCategory) &&
            selectedSizeCategory.length > 0
          ? getCategoryId(selectedSizeCategory[0])
          : null;

        if (currentActiveTab === null || currentActiveTab === undefined)
          return null;

        const categoryData = groupedByCategory?.[currentActiveTab] ?? null;
        const categorySizes =
          options?.filter(
            (size) => size.category_id == currentActiveTab && !size.size_deleted
          ) || [];

        // Use memoized regions for active category
        const displayRegions =
          currentActiveTab === activeCategoryTab
            ? activeCategoryRegions
            : sizeRegions.length > 0
            ? sizeRegions
            : [{ id: 0, region: "Default", region_ar: "افتراضي" }];

        const currentDraftRows = addSizesLines.filter(
          (row) => row.category_id == currentActiveTab
        );

        const totalRowsInCategory =
          categorySizes.length + currentDraftRows.length;
        const canDelete = totalRowsInCategory > 1;

        if (displayRegions.length === 0) {
          return (
            <div className="text-center p-3">
              No regions available for this category
            </div>
          );
        }

        return (
          <div className=" size-table ">
            <table className=" table-size w-100">
              <thead>
                <tr className="table-head">
                  {displayRegions.map((r) => (
                    <th key={r.id} className="text-center">
                      {language == "English" ? r.region : r?.region_ar}
                    </th>
                  ))}
                  {type != "deleted" && (
                    <th className="text-center">
                      {language == "English" ? "Action" : "اقدام"}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* EXISTING SIZES (from API) */}
                {categorySizes.map((size) => (
                  <tr key={size.size_id}>
                    {displayRegions.map((r) => {
                      const cell = size.size_text.find((t) => t.region == r.id);
                      return (
                        <td key={r.id} className="text-center text-nowrap ">
                          {editSizeId == size.size_id ? (
                            language == "English" ? (
                              <input
                                className="form-control form-control-sm"
                                value={cell?.text || ""}
                                onChange={(e) =>
                                  handleEditSize(
                                    e.target.value,
                                    r.id,
                                    size.size_id
                                  )
                                }
                              />
                            ) : (
                              <input
                                className="form-control form-control-sm"
                                value={cell?.text_ar || ""}
                                onChange={(e) =>
                                  handleEditSize_ar(
                                    e.target.value,
                                    r.id,
                                    size.size_id
                                  )
                                }
                              />
                            )
                          ) : language == "English" ? (
                            cell?.text
                          ) : (
                            cell?.text_ar || "-"
                          )}
                        </td>
                      );
                    })}
                    {type != "deleted" && (
                      <td className="text-center">
                        {editSizeId == size.size_id ? (
                          <>
                            <i
                              className="bi bi-check2 text-success cursor-pointer"
                              title="Save"
                              onClick={() => handleSaveChanges()}
                            />
                            <i
                              className="bi bi-x text-secondary ms-2 cursor-pointer"
                              title="Cancel"
                              onClick={() => {
                                setEditSizeId("");
                                handleGetSize();
                              }}
                            />
                          </>
                        ) : (
                          <i
                            className="far fa-edit text-info cursor-pointer fs-5"
                            title="Edit"
                            onClick={() => handleEditClick(size.size_id)}
                          />
                        )}
                        {user?.role != "store-manager" &&
                          (canDelete ? (
                            <i
                              className="bi bi-trash3 text-danger ms-2 cursor-pointer fs-5"
                              onClick={() =>
                                //  handleDeleteSize(size.size_id)
                                {
                                  setOpenSize(true);
                                  setSizeId(size?.size_id);
                                }
                              }
                            />
                          ) : (
                            <i
                              className="bi bi-trash3 text-secondary ms-2"
                              style={{ opacity: 0.3, cursor: "not-allowed" }}
                            />
                          ))}
                      </td>
                    )}
                  </tr>
                ))}

                {/* NEWLY ADDED ROWS */}
                {language == "English" &&
                  currentDraftRows.map((row) => (
                    <tr key={row.id} className="table-warning">
                      {displayRegions.map((r, idx) => (
                        <td key={r.id} className="text-center ">
                          <input
                            className="form-control form-control-sm"
                            value={row.region[idx]?.text || ""}
                            onChange={(e) =>
                              addTextRelatedRegions(e.target.value, idx, row.id)
                            }
                          />
                        </td>
                      ))}
                      <td className="text-center ">
                        {canDelete ? (
                          <i
                            className="bi bi-trash3 text-danger cursor-pointer"
                            onClick={() => handleDeleteLine(row.id)}
                          />
                        ) : (
                          <i
                            className="bi bi-trash3 text-secondary"
                            style={{ opacity: 0.3, cursor: "not-allowed" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                {language == "Arabic" &&
                  currentDraftRows.map((row) => (
                    <tr key={row.id} className="table-warning">
                      {displayRegions.map((r, idx) => (
                        <td key={r.id} className="text-center">
                          <input
                            className="form-control form-control-sm"
                            value={row.region[idx]?.text_ar || ""}
                            onChange={(e) =>
                              addTextRelatedRegions_ar(
                                e.target.value,
                                idx,
                                row.id
                              )
                            }
                          />
                        </td>
                      ))}
                      <td className="text-center">
                        {canDelete ? (
                          <i
                            className="bi bi-trash3 text-danger cursor-pointer"
                            onClick={() => handleDeleteLine(row.id)}
                          />
                        ) : (
                          <i
                            className="bi bi-trash3 text-secondary"
                            style={{ opacity: 0.3, cursor: "not-allowed" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>{" "}
          </div>
        );
      })()}

      {selectedGender && all.find((g) => g.gender_id == selectedGender) && (
        <div>
          <button className="btn btn-dark" onClick={() => handleAddSizes()}>
            Submit
          </button>
        </div>
      )}
      {openSize && (
        <DeletePopup
          open={openSize}
          setOpen={setOpenSize}
          handleDelete={handleDeleteSize}
          label="Are you sure , you wanna delete the size"
        />
      )}
    </div>
  );
};

export default ViewSizes;
